import { Injectable } from '@angular/core';
import { BoxAiRequestDto } from '../pojo/BoxAiRequestDto';
import { UrlService } from '../../../../../environments/urlService';
import { defer, from, mergeMap, Observable } from 'rxjs';
import { processStream } from '../../../../util/stream/stream-utils';
import { finalize } from 'rxjs/operators';
import { HttpClient, HttpContext } from '@angular/common/http';
import { IS_SPINNER_ACTIVE } from '../../../../util/interceptors';
import { AiHistoryMessage } from '../../../global-ai/utils';

@Injectable({
  providedIn: 'root',
})
export class DocumentsAiBackendService {
  private readonly url: string;

  constructor(
    private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'documents-ai';
  }

  sendRequestGetStreamedResponse(request: BoxAiRequestDto): Observable<string> {

    return defer((): Observable<string> => {
      const controller = new AbortController();

      return from(
        fetch(`${this.url}/chat`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'text/plain',
            'Cache-Control': 'no-cache',
          },
          body: JSON.stringify(request),
          credentials: 'include',
          signal: controller.signal,
        })
      ).pipe(
        mergeMap((response): Observable<string> => {
          if (!response.ok) {
            console.error(`Error while getting pinned docs chat response: ${response.statusText}`);
            throw new Error('There is an error connecting to the AI server');
          }
          const reader = response.body.getReader();
          const decoder = new TextDecoder();

          // return the stream decoding the chunks
          return processStream(reader, decoder);
        }),
        finalize((): void => {
          controller.abort();
        })
      );
    });
  }

  fetchConversationHistory(fileId: string): Observable<AiHistoryMessage[]> {
    return this.http.get<AiHistoryMessage[]>(this.url + '/chat-history', {
      params: { fileId },
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  clearHistory(fileId: string): Observable<void> {
    return this.http.delete<void>(this.url + '/clear-history', {
      params: { fileId },
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }
}
